
export async function loadRecipes(apiUrl: string) {
  try {
    const res = await fetch(`${apiUrl}/api/recipes`);
    const data = await res.json();
    const list = document.querySelector("#recipes");
    if (list)
      list.innerHTML = data.map(r => `<li><strong>${r.title}</strong><br />${r.content}</li>`).join('');
  } catch (err) {
    console.error("Fehler beim Laden der Rezepte:", err);
  }
}
